module.exports = __webpack_public_path__ + "img/fr_Logo_OVT.8a2d3f18.png";